import React from 'react';
import { useTranslation } from 'react-i18next';

import { SectionCard, WhiteCard } from 'src/components';

import { AmicoTransaction } from 'src/assets';
import './exchangePoint.scss';

export const ExchangePoint = () => {
  const { t } = useTranslation('exchangePoint');

  return (
    <div className="exchange-point">
      <img src={AmicoTransaction} alt={AmicoTransaction} className="exchange-point__image" />
      <SectionCard title={t('welcome')}>
        <WhiteCard>{t('description')}</WhiteCard>
      </SectionCard>
    </div>
  );
};
